var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39759 12.8314L5.57829 14.4217L7.16865 17.6024L8.759 16.0121V13.6265L11.5421 10.8434L13.9276 18L16.3132 15.6145L14.3252 8.06029L17.5059 4.87959C18.1647 4.22084 18.1647 3.15281 17.5059 2.49406C16.8472 1.83531 15.7792 1.83531 15.1204 2.49406L11.9397 5.67476L4.38553 3.68682L2 6.07235L9.15659 8.45788L6.37347 11.241H3.98794L2.39759 12.8314Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.7fe52dfef71dc162e9ea8b95e4f030c3.svg";
export { ForwardRef as ReactComponent };